export default __webpack_public_path__ + "static/media/profile-image.4bfc7224.jpg";